export const FloatingPanelSize = {
    LARGE: 'lg',
    SMALL: 'sm'
};

export const FloatingPanelType = {
    STANDARD: 'standard',
    DESTRUCTIVE: 'destructive'
};
